import React from 'react'

import './HomeHod.css'

function HomeHod() {
  return (
    <div className='homeHod'>
      <div className='home_hod_section__container'>
        <div className='section'>
          <div className='homeHod_section'>
            <div className='hod__right' data-aos="fade-right">
              <img className='homehod__img' src='https://res.cloudinary.com/dwaynojlz/image/upload/v1747983040/tvpmmvkwxq9t9j0gdagi.jpg' alt='' />
            </div>
            <div className='hod__left' data-aos="fade-up">
              <h1 className='white_section__header' data-aos="fade-up">Message from The HOD</h1>
              <p className='hod__p' data-aos="fade-up">
                Greetings!
                <br />
                Welcome to the Department of Computer Engineering, Government Model Engineering College, Thrikkakara.
                <br />
                <br />
                It is with great pride that I welcome you to the Department of Computer Engineering at Government Model Engineering College, Cochin. As one of the flagship departments of the institution, we are committed to delivering high-quality technical education while fostering a culture of academic excellence, innovation, and ethical responsibility. The department is accredited by the National Board of Accreditation (NBA), underscoring our adherence to the highest standards in engineering education. Since its affiliation to APJ Abdul Kalam Technological University (KTU) in 2015, the department has consistently secured top ranks in university examinations, reflecting the academic rigor and dedication of our faculty and students.
                <br /><br/>
                Our department takes pride in achieving 100% placement year after year in leading national and multinational companies, with our graduates being recruited by top firms including Google, among others. This outstanding placement record is a result of our strong industry engagement, focused skill development programs, and a well-rounded academic framework. Through a blend of advanced curriculum, research initiatives, and co-curricular opportunities, we strive to develop competent professionals capable of leading and innovating in a dynamic technological landscape. I warmly invite you to explore the department and be a part of its continuing journey toward excellence
                <br />
              </p>
              <h3 data-aos="fade-up">                -<a href="https://sites.google.com/view/drbinuvp/home" 
                    target="_blank" 
                    rel="noopener noreferrer">
                  Dr Binu V P
                </a></h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeHod